import React from 'react';

interface IProps {
  id: string;
  currentPage: number;
  totalPages: React.ReactNode[] | React.ReactNode;
  lightBackground?: boolean;
  className?: string;
  smallIndicatorSpacing?: boolean;
  onClick: (page: number) => void;
}

export const ImagePageIndicator = ({
  currentPage,
  totalPages,
  id,
  lightBackground = true,
  className = '',
  smallIndicatorSpacing = false,
  onClick,
}: IProps) => {
  return Array.isArray(totalPages) ? (
    <div
      className={`mx-auto flex space-x-2 pb-4 ${
        smallIndicatorSpacing ? 'mt-2' : 'mt-6'
      } ${className}`}
      data-testid="PageIndicator"
    >
      {totalPages.map((image, i) =>
        lightBackground ? (
          <button
            type="button"
            key={`${id}-p-${i}`}
            onClick={() => {
              onClick(i + 1);
            }}
            className={`w-20 ${currentPage === i + 1 ? 'border-tuna border-2' : 'border-0'}`}
          >
            {image}
          </button>
        ) : (
          <button
            type="button"
            key={`${id}-p-${i}`}
            onClick={() => {
              onClick(i + 1);
            }}
            className="w-20"
          >
            {image}
          </button>
        ),
      )}
    </div>
  ) : (
    <></>
  );
};
